var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg023Relation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z",
    fill: "#ffe6e2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fd907e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16 12.833c-.276 0-.5-.224-.5-.5v-2c0-.276.224-.5.5-.5s.5.224.5.5v2c0 .276-.224.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.592 13.907c-.128 0-.256-.049-.354-.146-.195-.195-.195-.512 0-.707l1.415-1.414c.196-.196.512-.195.707 0s.195.512 0 .707l-1.415 1.414c-.097.097-.225.146-.353.146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.667 16.5h-2c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2c.276 0 .5.224.5.5s-.224.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.007 20.507c-.128 0-.256-.049-.354-.146l-1.415-1.414c-.195-.195-.195-.512 0-.707s.512-.196.707 0l1.415 1.414c.195.195.195.512 0 .707-.097.097-.225.146-.353.146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 22.167c-.276 0-.5-.224-.5-.5v-2c0-.276.224-.5.5-.5s.5.224.5.5v2c0 .276-.224.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.993 20.507c-.128 0-.256-.049-.354-.146-.195-.195-.195-.512 0-.707l1.415-1.414c.196-.196.512-.195.707 0s.195.512 0 .707l-1.415 1.414c-.097.097-.226.146-.353.146z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.333 16.5h-2c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2c.276 0 .5.224.5.5s-.224.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.408 13.907c-.128 0-.256-.049-.354-.146l-1.415-1.414c-.195-.195-.195-.512 0-.707s.511-.196.707 0l1.415 1.414c.195.195.195.512 0 .707-.098.097-.225.146-.353.146z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 9.333,
    r: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.714 12.618c.341 0 .683-.13.943-.389.52-.52.52-1.366 0-1.886-.52-.519-1.366-.519-1.885 0-.52.52-.52 1.366 0 1.886.259.26.601.389.942.389z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.667,
    cy: 16,
    r: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.772 19.771c-.52.52-.52 1.366 0 1.886.26.259.602.389.943.389s.683-.13.943-.39c.52-.52.52-1.366 0-1.886-.521-.518-1.367-.518-1.886.001z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 22.667,
    r: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.343 19.771c-.52.52-.52 1.366 0 1.886.26.259.602.389.943.389s.683-.13.943-.39c.52-.52.52-1.366 0-1.886-.52-.518-1.366-.518-1.886.001z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.333,
    cy: 16,
    r: 1.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.228 10.343c-.52-.519-1.366-.519-1.885 0-.52.52-.52 1.366 0 1.886.26.259.602.389.943.389s.683-.13.943-.39c.52-.519.52-1.365-.001-1.885z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16 12c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm-.083 3.5h.167c.689 0 1.25.561 1.25 1.25 0 .542-.349 1.001-.833 1.173v.243c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-.166h-.333c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h.917c.138 0 .25-.112.25-.25s-.112-.25-.25-.25h-.167c-.689 0-1.25-.561-1.25-1.25 0-.542.349-1.001.833-1.173v-.243c0-.276.224-.5.5-.5s.5.224.5.5v.166h.333c.276 0 .5.224.5.5s-.224.5-.5.5h-.917c-.138 0-.25.112-.25.25s.112.25.25.25z",
    fill: "#fc573b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg023Relation);
export default __webpack_public_path__ + "static/media/023-relation.760521cbdc86e0825eb889ca8621cbb4.svg";
export { ForwardRef as ReactComponent };